const LEKO_TECH_ADMIN_ROLES = new Set(['LekoAdmin', 'LekoEmployee', 'SuperAdmin']);

export const PORTAL_PERMISSIONS = {
  WHATSAPP_INBOX: 'whatsapp_inbox',
};

export function isLekoTechAdmin(role) {
  return LEKO_TECH_ADMIN_ROLES.has(role);
}

export function hasPortalPermission(store, permission) {
  if (!store || !permission) {
    return false;
  }
  const role = store.getters.role;
  if (isLekoTechAdmin(role)) {
    return true;
  }
  const perms = store.getters.permissions || [];
  return perms.includes(permission);
}
